export default (current, target, detla) => ((current-(target-detla))*(current-(target+detla)) <= 0);
